module.exports = __webpack_public_path__ + "static/img/s5.62409499.png";